module.exports = __webpack_public_path__ + "static/media/2.270c6707.jpg";